<div class="app-info" [class.arebic-content]="textDirection == 'rtl'">
    <div class="col-5 app-title">
        <div class="app-details">
            <h4 translate>HOME_PAGE.TALY_APP_DESC</h4>
            <span translate>HOME_PAGE.QR_CODE</span>
            <a href="javascript:void(0)" target="_blank"  (click)="envService?.onLinkClick($event, appLink)">
                <img class="qr-code" src="assets/images/taly-qr-code.svg" alt="QR Code">
                <img class="app-download" [src]="appIcon" alt="QR Code">
            </a>
        </div>
    </div>
    <div class="col-5"></div>
</div>